import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import Table from 'apollo-react/components/Table';
import EllipsisHorizontal from 'apollo-react-icons/EllipsisHorizontal';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { getUITA } from '../../../../utils/commonUtils';

const useStyles = makeStyles({
  deltaChanges: {
    '&  div[class*="MuiToolbar-root"]': {
      border: '1px solid blue',
    },
  },
  uiChanges: {
    '&  div[class*="MuiToolbar-root"]': {
      border: '1px solid orange',
    },
  },
});

const ControlPropertiesTable = ({
  title,
  type,
  columns,
  rows,
  handleClick,
  hasUIChange,
  deltaChanges,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const openModal = () => {
    handleClick(type);
  };

  const CustomHeader = () => (
    <div>
      <IconButton
        aria-label={translateString(`Add ${type} Rules Button`)}
        variant="primary"
        ui-ta={getUITA('Add', type, 'Rules Button')}
        onClick={openModal}
      >
        <EllipsisHorizontal />
      </IconButton>
    </div>
  );

  return (
    <Table
      title={title}
      classes={{
        root: hasUIChange ? classes.uiChanges : deltaChanges ? classes.deltaChanges : '',
      }}
      className={classes.custom}
      columns={columns}
      rows={rows}
      hidePagination
      CustomHeader={CustomHeader}
    />
  );
};

export default ControlPropertiesTable;
